<template>
  <el-row v-loading="loading">
    <el-row class="padding_5px_top padding_10px_bottom">
      <el-col :span="20">
        <el-col
          :span="24"
          class="left_text_align"
        >
          <span class="padding_10px_right">
            <el-popover              
              placement="bottom"
              width="100"
              trigger="click"
              v-model="setVisible"
            >
              <ul style="display: flex;flex-direction: column;">
                <el-button
                  type="text"
                  @click="handleMyListData()"
                >我的列表</el-button>
                <el-button
                  type="text"
                  style="margin-left:0px;"
                  @click="handleSubscriptionData()"
                >发送条件</el-button>
              </ul>
              <el-button                
                slot="reference"
                icon="icon_set"
              >设置</el-button>
            </el-popover>	
          </span>
          <span class="padding_10px_left_righ">
            <!--el-popover
                            placement="bottom"
                            width="300"
                            v-model="downloadAllVisible"
                        >
                            <el-row
                                v-loading="dialogLoading"
                                style="text-align: center; margin: 0;"
                            >
                                <p>请确认是否发送全部报告到FTP</p>
                                <el-button
                                    size="small"
                                    class="button_space"
                                    round
                                    @click="downloadAllVisible = false"
                                    >取 消</el-button
                                >
                                <el-button
                                    size="small"
                                    class="button_space"
                                    type="primary"
                                    round
                                    @click="handleDownloadAll"
                                    >确 定</el-button
                                >
                            </el-row>
                            <el-button slot="reference" icon="icon_download"
                                >发送全部报告到FTP</el-button
                            >
                        </el-popover-->
            <el-button
              slot="reference"
              icon="icon_download"
              @click="downloadAllVisible = true"
            >发送全部报告到FTP</el-button>
          </span>
          <span class="padding_10px_left_righ">
            <el-button
              :disabled="downloadInProgress"
              icon="icon_download"
              @click="downloadAllFundReport()"
              >生成下载链接</el-button>
          </span>
          <span class="padding_10px_left_righ" v-if="showMyListImportAndCleanBtn">
            <el-button
              icon="icon_import"
              @click="importDialogVisible = true"              
            >导入基金代码</el-button>
          </span>
          <span class="padding_10px_left_righ" v-if="showMyListImportAndCleanBtn">
            <el-button
              icon="el-icon-delete"
              @click="removeMyList"                                       
            >清空基金代码</el-button>
          </span>
          <span class="padding_10px_left_righ">
            <el-button
              icon="icon_export"
              @click="exportDialogVisible = true"
              :disabled="disableExport"
            >导出数据列表</el-button>
          </span>
        </el-col>
      </el-col>
      <el-col
        :span="4"
        class="right_text_align searchInput"
      >
        <el-popover
          placement="bottom"
          width="380px"
          v-model="searchPopoverVisible"
        >
          <el-row
            style="width: 380px; height: 300px;"
            v-loading="loading2"
          >
            <el-scrollbar
              ref="search_scrollbar"
              style="height: 100%;"
            >
              <el-row
                style="
                                    text-align: left;
                                    margin: 0;
                                    font-size: 12px;
                                    cursor: pointer;
                                "
                v-for="(node, index) in state"
                class="fundInformation"
                :key="index"
              >
                <el-col
                  :span="24"
                  v-html="node"
                  @click.native="
                                        selectSymbolAutoComplete(node)
                                    "
                  :ref="'cssClass' + index"
                  @mouseenter.native="
                                        changeClass($event, index)
                                    "
                  :class="{ searchHover: 1 === index }"
                ></el-col>
              </el-row>
            </el-scrollbar>
          </el-row>
          <el-input
            placeholder="列表中搜索"
            slot="reference"
            type="text"
            v-model="symbol"
            @input="searchFundCache(symbol)"
          ></el-input>
        </el-popover>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="20">

        <!--my list setting dialog begin-->
        <el-dialog
          :visible.sync="myListSettingDialogVisible"
          width="525px"
          center
          :modal-append-to-body="false"
          :show-close="false"
          custom-class="customDialog"
        >
          <el-row v-loading="dialogLoading">
            <el-col
              :span="1"
              class="height_1px"
            ></el-col>
            <el-col :span="23">
              <el-row>
                <el-col class="dialog_title">我的列表</el-col>
              </el-row>
              <br />
              <el-row>
                <el-col
                  :span="6"
                  class="dialog_font"
                >基金列表</el-col>
                <el-col 
                  :span="18"
                  class="dialog_font"
                >
                  <el-radio v-model="myListType" label="0">自定义</el-radio>
                  <el-radio v-model="myListType" label="1">指定基金公司</el-radio>
                  <el-radio v-model="myListType" label="2" :disabled="!disableMyListTypeAllMarket">全市场基金</el-radio>                  
                </el-col>
              </el-row>
              <br />
              <el-row v-if="!disableMyListCompany">
                <el-col
                  :span="6"
                  class="dialog_font"
                >添加基金公司</el-col>
                <el-col
                  :span="18"                  
                >
                  <el-select                    
                    v-model="curCompanyName"
                    filterable
                    clearable
                    placeholder="请选择或输入公司首拼、关键字"
                    :filter-method="fiterCompany"
                    style="width:270px"                    
                  >
                    <el-option
                      v-for="item in filteredCompanyList"
                      :key="item.companyName"
                      :label="item.companyName"
                      :value="item.companyName"
                    >
                    </el-option>
                  </el-select><el-button                      
                      @click="handleAddCompany(curCompanyName)"                                     
                    >添加</el-button>
                </el-col>
              </el-row>
              <br v-if="!disableMyListCompany"/>
              <el-row v-if="!disableMyListCompany">
                <el-col
                  :span="6"
                  class="dialog_font"
                  style="line-height: 244px;"
                >基金公司列表</el-col>
                <el-col
                  :span="18"
                  style="width: 330px;"                  
                >
                  <el-col style="
                                            border-radius: 0px;
                                            width: 340px;
                                            border: 1px solid #c0c4cc;
                                            height: 244px;
                                        ">
                    <el-scrollbar
                      ref="scrollbarMyList"
                      style="height: 100%;"                      
                    >
                      <el-col
                        v-for="item in myListCompany"
                        :key="item.index"
                        :span="24"
                        class="padding_4px"                        
                      >
                        <el-tag
                          type="info"         
                          closable
                          @close="handleRemoveCompany(item)"                          
                        >{{ item }}</el-tag>
                      </el-col>
                    </el-scrollbar>
                  </el-col>
                </el-col>
              </el-row>
              <br v-if="!disableMyListCompany"/>
              <el-row>
                <el-col :span="13">&nbsp;
                </el-col>
                <el-col
                  :span="4"
                  class="right_text_align"
                  style="padding-right: 85px;"
                >
                  <el-button
                    size="small"
                    class="button_space"
                    round
                    @click="myListSettingDialogVisible = false"
                  >取 消</el-button>
                </el-col>
                <el-col
                  :span="5"
                  class="right_text_align padding_20px_left padding-right-30-important"
                >
                  <el-button
                    size="small"
                    class="button_space"
                    type="primary"
                    round
                    @click="saveConfigMyList"
                  >保 存</el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-dialog>
        <!--my list setting dialog end---->

        <!-- configSendDialogVisible dialog -->
        <el-dialog
          :visible.sync="configSendDialogVisible"
          width="525px"
          center
          :modal-append-to-body="false"
          :show-close="false"
          custom-class="customDialog"
        >
          <el-row v-loading="dialogLoading">
            <el-col
              :span="1"
              class="height_1px"
            ></el-col>
            <el-col :span="23">
              <el-row>
                <el-col class="dialog_title">设置发送条件</el-col>
              </el-row>
              <br />
              <el-row>
                <el-col
                  :span="8"
                  class="dialog_font"
                >发送频率</el-col>
                <el-col :span="15">
                  <el-select
                    v-model="selectFrequency"
                    class="frequency_input"
                  >
                    <el-option
                      selected="selected"
                      label="月度"
                      value="monthly"
                    ></el-option>
                    <el-option
                      label="季度"
                      value="quarterly"
                    ></el-option>
                    <!-- <el-option
                      label="半年度"
                      value="semi-annually"
                    ></el-option> -->
                  </el-select>
                </el-col>
              </el-row>
              <el-row>
                <el-col
                  :span="8"
                  class="dialog_font"
                >仅发送当期变动</el-col>
                <el-col
                  :span="15"
                  class="dialog_font"
                >
                  <!--el-radio
                                        v-model="radioRiskExcelChangedOnly"
                                        label="false"
                                        >否</el-radio
                                    >
                                    <el-radio
                                        v-model="radioRiskExcelChangedOnly"
                                        label="true"
                                        >是</el-radio
                                    -->
                  <el-checkbox v-model="radioRiskExcelChangedOnly"></el-checkbox>
                </el-col>
              </el-row>
              <el-row>
                <el-col
                  :span="8"
                  class="dialog_font"
                >接收管理人风险提醒</el-col>
                <el-col
                  :span="15"
                  class="dialog_font"
                >
                  <el-checkbox v-model="companyRiskAlertAvailable"></el-checkbox>
                </el-col>
              </el-row>
              <el-row>
                <el-col
                  :span="8"
                  class="dialog_font"
                  style="line-height: 244px;"
                >发送邮箱</el-col>
                <el-col
                  :span="16"
                  style="width: 253px;"
                >
                  <el-col style="
                                            border-radius: 0px;
                                            width: 300px;
                                            border: 1px solid #c0c4cc;
                                            height: 244px;
                                        ">
                    <el-scrollbar
                      ref="scrollbar"
                      style="height: 100%;"
                    >
                      <el-col
                        v-for="item in emailsParagraph"
                        :key="item.index"
                        :span="24"
                        class="padding_4px"
                      >
                        <el-tag
                          type="info"
                          closable
                          @close="
                                                        handleRemoveEmail(item)
                                                    "
                        >{{ item }}</el-tag>
                      </el-col>
                    </el-scrollbar>
                  </el-col>
                </el-col>
              </el-row>
              <br />
              <el-row>
                <el-col
                  :span="8"
                  class="dialog_font"
                >添加发送邮箱</el-col>
                <el-col :span="16">
                  <el-input
                    placeholder="请输入内容"
                    v-model="emailInput"
                    class="input-with-select"
                    @keyup.enter.native="
                                            handleAddEmail(emailInput)
                                        "
                  >
                    <el-button
                      slot="append"
                      @click="handleAddEmail(emailInput)"
                      :disabled="disableExport"
                    >添加</el-button>
                  </el-input>
                </el-col>
              </el-row>
              <br />
              <el-row>
                <el-col
                  :span="8"
                  class="dialog_font"
                >三维度数据</el-col>
                <el-col
                  :span="15"
                  class="dialog_font"
                >
                  <el-checkbox v-model="radioThreeDimensions"></el-checkbox>
                </el-col>
              </el-row>
              <br />
              <el-row>
                <el-col
                  :span="8"
                  class="dialog_font"
                >孰高结果</el-col>
                <el-col
                  :span="15"
                  class="dialog_font"
                >
                  <el-checkbox v-model="radioHighestRisk"></el-checkbox>
                </el-col>
              </el-row>
              <el-row>
                <el-col
                  :span="8"
                  class="dialog_font"
                >剔除已终止基金</el-col>
                <el-col
                  :span="15"
                  class="dialog_font"
                >
                  <el-checkbox v-model="radioRemoveEndFund"></el-checkbox>
                </el-col>
              </el-row>
              <br />
              <el-row>
                <el-col :span="14">
                  <el-button
                    size="small"
                    class="button_space"
                    round
                    @click="
                                            handleSendFrequencyReportByEmail
                                        "
                    :disabled="disableExport"
                  >立即发送</el-button>
                </el-col>
                <el-col
                  :span="4"
                  class="right_text_align"
                  style="padding-right: 85px;"
                >
                  <el-button
                    size="small"
                    class="button_space"
                    round
                    @click="configSendDialogVisible = false"
                  >取 消</el-button>
                </el-col>
                <el-col
                  :span="4"
                  class="right_text_align padding_20px_left"
                >
                  <el-button
                    size="small"
                    class="button_space"
                    type="primary"
                    round
                    @click="handleConfigFrequency"
                  >保 存</el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-dialog>
        <!-- downloadAllVisible dialog -->
        <el-dialog
          :visible.sync="downloadAllVisible"
          width="350px"
          center
          :modal-append-to-body="true"
          custom-class="customDialog"
          :show-close="false"
        >
          <el-row v-loading="dialogLoading">
            <el-row
              v-loading="dialogLoading"
              style="text-align: center; margin: 0;"
            >
              <p>请确认是否发送全部报告到FTP</p>
              <el-button
                size="small"
                class="button_space"
                round
                @click="downloadAllVisible = false"
              >取 消</el-button>
              <el-button
                size="small"
                class="button_space"
                type="primary"
                round
                @click="handleDownloadAll"
              >确 定</el-button>
            </el-row>
          </el-row>
        </el-dialog>
        <!-- importDialogVisible dialog -->
        <el-dialog
          :visible.sync="importDialogVisible"
          width="485px"
          center
          :modal-append-to-body="false"
          custom-class="customDialog"
          :show-close="false"
        >
          <el-row v-loading="dialogLoading">
            <el-col :span="24">
              <el-form
                ref="importFile"
                :model="importFileModel"
                name="importFile"
                label-width="10px"
                method="post"
              >
                <el-row>
                  <el-form-item>
                    <el-col :span="24">
                      <el-upload
                        class="upload-demo"
                        ref="upload"
                        :show-file-list="true"
                        :http-request="
                                                    uploadSectionFile
                                                "
                        action=""
                        :auto-upload="false"
                        :multiple="false"
                        :limit="1"
                      >
                        <el-button
                          slot="trigger"
                          size="small"
                          type="primary"
                        >导入文件</el-button>
                        <span
                          style="padding-left: 17px;"
                          class="right_text_align"
                          slot="tip"
                        >点击左边按钮导入文件
                        </span>
                      </el-upload>
                    </el-col>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item>
                    <el-col
                      :span="9"
                      class="dialog_font"
                    >文件类型</el-col>
                    <el-col
                      :span="15"
                      class="right_text_align"
                    >
                      <el-select
                        v-model="
                                                    importFileModel.fileType
                                                "
                        placeholder="Select"
                        class="import_input"
                      >
                        <el-option
                          v-for="item in fileTypeOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item>
                    <el-col
                      :span="9"
                      class="dialog_font"
                    >标识符</el-col>
                    <el-col
                      :span="15"
                      class="right_text_align"
                    >
                      <el-select
                        v-model="importFileModel.flag"
                        placeholder="Select"
                        class="import_input"
                      >
                        <el-option
                          v-for="item in flagTypeOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-col class="flag_message">您文件中仅有的那一栏就是标识符。</el-col>
                </el-row>
                <el-row>
                  <el-col
                    :span="9"
                    class="left_text_align"
                    style="padding-left:8px;"
                  >
                    <el-button
                      round
                      size="small"
                      class="button_space"
                      @click="handleShowHelp"
                    >帮 助</el-button>
                  </el-col>
                  <el-col
                    :span="15"
                    class="right_text_align"
                  >
                    <el-button
                      round
                      size="small"
                      class="button_space"
                      @click="importDialogVisible = false"
                    >取 消</el-button>
                    <el-button
                      round
                      size="small"
                      class="button_space"
                      type="primary"
                      @click="handleImportFile"
                    >确 定</el-button>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
          </el-row>
        </el-dialog>
        <!-- exportDialogVisible dialog -->
        <el-dialog
          :visible.sync="exportDialogVisible"
          width="350px"
          center
          :modal-append-to-body="true"
          custom-class="customDialog"
          :show-close="false"
        >
          <el-row v-loading="exportDialogLoading">
            <el-row>
              <el-col
                class="dialog_title"
                style="
                                    padding-bottom: 16px;
                                    font-size: 14px;
                                    font-weight: bold;
                                    text-align: center;
                                "
              >导出格式</el-col>
              <el-col
                :span="24"
                class=""
              >
                <el-select
                  v-model="selectFormat"
                  class="export_inputBox"
                  style="width: 100%;"
                >
                  <el-option
                    selected="selected"
                    label="Excel"
                    value="xlsx"
                  ></el-option>
                  <el-option
                    label="CSV"
                    value="csv"
                  ></el-option>
                  <el-option
                    label="PDF"
                    value="pdf"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col
                :span="11"
                class="right_text_align"
              >
                <el-button
                  size="small"
                  class="button_space"
                  round
                  @click="exportDialogVisible = false"
                >取 消</el-button>
              </el-col>
              <el-col
                :span="13"
                class="left_text_align"
                style="padding-left: 20px;"
              >
                <el-button
                  size="small"
                  class="button_space"
                  type="primary"
                  round
                  @click="handleExportFile(selectFormat,showingThreeDimensions)"
                >导 出</el-button>
              </el-col>
            </el-row>
          </el-row>
        </el-dialog>
      </el-col>
    </el-row>
    <div class="line"></div>
    <el-dialog
      title="管理人风险变更"
      :visible.sync="notificationVisible"
      width="30%"
    >
      <div style="text-align: left">
        <p>您关注的列表中，部分基金其管理人出具的风险评价有变化，该调整对最新晨星评价与管理人评价的比较结果或有影响，特此提醒，具体变动请查看邮件通知。
        </p>
      </div>
      <p>（点击确定当日不再提醒）</p>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          size="medium"
          style="height: 38px"
          @click="handleRiskCompanyAlert"
        >确 定</el-button>
      </span>
    </el-dialog>

    <el-table
      :data="tableData"
      @sort-change="sortChange"
      :default-sort="{ prop: 'defaultSymbol', order: 'descending' }"
      style="width: 100%;"
      :key="Math.random()"
    >
      <el-table-column
        fixed
        type="index"
        label="序号"
        width="71"
        :key="Math.random()"
      ></el-table-column>
      <el-table-column
        fixed
        sortable="custom"
        prop="defaultSymbol"
        label="基金代码"
        width="120"
        :key="Math.random()"
      ><template slot-scope="scope">
          <el-button
            @click="
                            redirectRiskLevelDataBase(scope.row.defaultSymbol)
                        "
            type="text"
            size="small"
          >{{ scope.row.defaultSymbol }}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        fixed
        prop="className"
        label="基金名称"
        width="241"
        show-overflow-tooltip
        :key="Math.random()"
      >
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="totalRisk"
        label="风险等级"
        width="110"
        align="center"
        :key="Math.random()"
      >
      </el-table-column>
      <el-table-column
        prop="riskText"
        label="风险说明"
        width="156"
        :key="Math.random()"
      >
      </el-table-column>
      <el-table-column
        prop="effectiveDate"
        label="评估时间"
        width="127"
        :key="Math.random()"
      >
        <template slot-scope="scope">
          {{ scope.row.effectiveDate | replaceTime }}
        </template>
      </el-table-column>
      <el-table-column
        prop="preTotalRisk"
        label="上期风险"
        align="center"
        width="110"
        :key="Math.random()"
      >
        <template slot-scope="scope">
          {{ scope.row.preTotalRisk | fillNull  }}
        </template>
      </el-table-column>
      <el-table-column
        prop="preRiskText"
        label="上期风险说明"
        width="134"
        :key="Math.random()"
      >
        <template slot-scope="scope">
          {{ scope.row.preRiskText | fillNull  }}
        </template>
      </el-table-column>
      <el-table-column
        prop="comparePreTotalRisk"
        sortable="custom"
        label="与上期比较"
        width="120"
        align="left"
        :key="Math.random()"
      >
        <template slot-scope="scope">
          <span class="margin-left-20-important">{{ scope.row.comparePreTotalRisk | fillNull }}<i
              v-if="scope.row.comparePreTotalRisk == '下降'"
              class="el-icon-bottom iconBottom"
            ></i><i
              v-if="scope.row.comparePreTotalRisk == '上升'"
              class="el-icon-top iconTop"
            ></i></span>
        </template>
      </el-table-column>

     <el-table-column
        prop="adjustmentOfReason"
        label="风险变动原因"
        width="134"
        :key="Math.random()"
      >
        <template slot-scope="scope">
          {{ scope.row.adjustResonOfTotalRisk | fillNull  }}
        </template>
      </el-table-column>   

      <el-table-column
        prop="preEffectiveDate"
        label="上期评价时间"
        width="130"
        :key="Math.random()"
      >
        <template slot-scope="scope">
          {{ scope.row.preEffectiveDate | replaceTime }}
        </template>
      </el-table-column>
      <el-table-column
        prop="specialCategory"
        sortable="custom"
        label="基金类型"
        width="150px"
        show-overflow-tooltip
        :key="Math.random()"
      >
      </el-table-column>
      <el-table-column
        prop="period"
        label="封闭期限"
        width="100px"
        align="center"
        :key="Math.random()"
      >
        <template slot-scope="scope">
          {{ scope.row.period | fillNull }}
        </template>
      </el-table-column>
      <el-table-column
        prop="unit"
        label="封闭期限单位"
        width="120px"
        align="center"
        :key="Math.random()"
      >
        <template slot-scope="scope">
          {{ scope.row.unit | fillNull }}
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="totalRiskCompanyLevel"
        label="管理人风险等级"
        width="150px"
        align="center"
        :key="Math.random()"
      >
        <template slot-scope="scope">
          {{ scope.row.totalRiskCompanyLevel | fillNull }}
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="lastUpdateCompanyLevel"
        label="管理人评级更新时间"
        width="170px"
        align="center"
        :key="Math.random()"
      >
        <template slot-scope="scope">
          {{ scope.row.lastUpdateCompanyLevel | replaceTime }}
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="compareTotalRiskCompanyLevel"
        label="是否低于管理人评级"
        width="170px"
        align="center"
        :key="Math.random()"
      >
        <template slot-scope="scope">
          {{ scope.row.compareTotalRiskCompanyLevel | replaceTime }}
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="highestRisk"
        label="孰高结果"
        width="170px"
        align="center"
        :key="Math.random()"
        v-if="showingHighestRisk"
      >
        <template slot-scope="scope">
          {{ scope.row.highestRisk | fillNull}}
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="investmentTypeNESC"
        label="投资类别"
        width="150px"
        align="center"
        :key="Math.random()"
        v-if="showingThreeDimensions"
      >
        <template slot-scope="scope">
          {{ scope.row.investmentTypeNESC | fillNull }}
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="incomeTypeNESC"
        label="收益类型"
        width="150px"
        align="center"
        :key="Math.random()"
        v-if="showingThreeDimensions"
      >
        <template slot-scope="scope">
          {{ scope.row.incomeTypeNESC | fillNull }}
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="periodTypeNESC"
        label="产品期限"
        width="150px"
        align="center"
        :key="Math.random()"
        v-if="showingThreeDimensions"
      >
        <template slot-scope="scope">
          {{ scope.row.periodTypeNESC | fillNull }}
        </template>
      </el-table-column>
      <el-table-column
        prop="targetFolder"
        label="基金风险报告"
        width="120px"
        align="center"
        :key="Math.random()"
      >
        <template slot-scope="scope">
          <el-button
            @click="
                            onClickDownload({
                                type: 'ftpFile',
                                url: scope.row.targetFolder,
                                fileName: scope.row.className,
                            })
                        "
            size="small"
            :disabled="disableExport"
          >下载</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col class="left_text_align padding_25px_top">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="(pagination && pagination.count) || 0"
        v-if="pagination.count > 10 ? true : false"
      >
      </el-pagination>
    </el-col>
  </el-row>

</template>
<script>
import { Message } from "element-ui";
import {
    getLatestEvaluation,
    getFundBySymbol,
    sendAllReportByFTP,
  removeMyList,
  getDownloadFundReport,
  getFundReports,
  getFundReportsStatus,
  deleteFundReportsStatus
} from "../../api/suitability";

import { importFile } from "./mixin/importFile";
import { fiterCompany } from "./mixin/fiterCompany";
import { frequencyConfig } from "./mixin/frequencyConfig";
import { myListConfig } from "./mixin/myListConfig";

const componentsCommon = require("cb-components-common").default;
const getSuitabilityMemberSenior = componentsCommon.common.getSuitabilityMemberSenior;
const getSuitabilityMemberSeniorTrial = componentsCommon.common.getSuitabilityMemberSeniorTrial;
const getMyListTypeByCustom = componentsCommon.common.getMyListTypeByCustom;

const checkResponseStatus = componentsCommon.common.checkResponseStatus;
const getDisableExport = componentsCommon.common.getDisableExport;
const getSuitabilityMemberBaseTrial = componentsCommon.common.getSuitabilityMemberBaseTrial;
const removeNameAndValue = componentsCommon.localStorage.removeNameAndValue;
const setNameAndValue = componentsCommon.localStorage.setNameAndValue;
const getNameAndValue = componentsCommon.localStorage.getNameAndValue;
const createLinkForDownload =
    componentsCommon.downloadUtils.createLinkForDownload;
const SearchByAutoComplete = componentsCommon.search.SearchByAutoComplete;
const getFundCache = componentsCommon.apiCommon.getFundCache;
const getFundCacheForMyList = componentsCommon.apiCommon.getFundCacheForMyList;
const searchBox = componentsCommon.mixin.searchBox.searchBox;
const exportFile = componentsCommon.mixin.exportFile.exportFile;


export default {
    mixins: [importFile, exportFile, frequencyConfig, searchBox, fiterCompany, myListConfig],    
    data() {
        return {
            exportDialogVisible: false,
            exportDialogLoading: false,
            symbol: "",
            searchPopoverVisible: false,
            downloadAllVisible: false,
            dialogLoading: false,
            symbolList: [],
            myListSettingDialogVisible: false,
            configSendDialogVisible: false,
            importDialogVisible: false,
            exportDialogVisible: false,
            ftpDialogVisible: false,
            notificationVisible: false,
            loading: false,
            tableData: [],
            pageSize: 0,
            selectFormat: "xlsx",            
            pagination: {
                skip: 0,
                limit: 10,
                count: 0
            },
            params: {
                sort: "DefaultSymbol",
                order: "desc",
                limit: 10,
                skip: 0,
                page: 1
            },
            disableExport: true,
            showingThreeDimensions: false,
            curCompanyName:'' ,
            companyList: [],
            filteredCompanyList: [],
            disableMyListTypeAllMarket: false,
            showMyListImportAndCleanBtn: false,
          showingHighestRisk: false,
          downloadInProgress: false,
          downloadLink: '', 
        };
    },
    filters: {
        fillNull(value) {
            if (value != undefined && value != null && value != "") {
                return value;
            } else {
                return "--";
            }
        },
        replaceTime(value) {
            if (value != undefined && value != null && value != "") {
                return value.replace("00:00:00.0", "");
            } else {
                return "--";
            }
        }
    },
    mounted() {
        const self = this;
        self.loadingData();

        self.handleCompany();

        this.disableExport = getDisableExport()||getSuitabilityMemberBaseTrial();     
        self.disableMyListTypeAllMarket = getSuitabilityMemberSeniorTrial() || getSuitabilityMemberSenior();   
        // this.pollDownloadLink();    
    },
    methods: {

        onClickDownload(param) {
          Message({
                    message: "正在下载：" + param.fileName + ",请耐心等待！",
                    duration: 2 * 1000
                });
          exportFile.methods.downloadFile(param);
        },

        showUnidentifiedData() {
            let unidentifiedList = getNameAndValue("unidentifiedList");
            unidentifiedList = JSON.parse(unidentifiedList);
            const blob = new Blob(["\ufeff" + unidentifiedList.join("\n")], {
                type: "text/csv;charset=utf-8"
            });
            createLinkForDownload(blob, "unidentifiedList.csv");
        },
        loadingData() {
            const self = this;
            self.fillConfigData();
            self.getData(self.params);

            let userInfo = JSON.parse(getNameAndValue("info"));
            if (userInfo != null && (userInfo.threeDimensions == "true" || userInfo.threeDimensions == true)) {
                self.showingThreeDimensions = true;
            } else {
                self.showingThreeDimensions = false;
            }
            self.showMyListImportAndCleanBtn = getMyListTypeByCustom();           

            if (userInfo != null && (userInfo.highestRisk == "true" || userInfo.highestRisk == true)) {
                self.showingHighestRisk = true;
            } else {
                self.showingHighestRisk = false;
            }            
        },
        handleSelect(key, keyPath) {
            const self = this;
            self.getData(self.params);
        },
        getData(params) {
            const self = this;
            self.loading = true;
            getLatestEvaluation(params)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message:
                                        "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000
                                });
                                Message.close = function() {};
                            } else {
                                self.pagination = result.pagination;
                                self.pageSize = result.pagination.count;
                                self.tableData = result.data.latestEvaluation;
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        handleSizeChange(val) {
            const self = this;
            self.params.limit = val;
            self.getData(self.params);
        },
        handleCurrentChange(val) {
            const self = this;
            self.params.page = val;
            self.params.skip = (val - 1) * self.params.limit;
            self.getData(self.params);
        },
        sortChange(column, prop, order) {
            let self = this;
            if (column.order != undefined) {
                self.params.order = column.order
                    .replace("ascending", "asc")
                    .replace("descending", "desc");
                self.params.sort = column.prop;
                self.getData(self.params);
            }
            console.log(column + "-" + column.prop + "-" + column.order);
        },
        redirectRiskLevelDataBase(symbol) {
            this.$emit("redirectRiskLevelDataBase", symbol);
        },
        searchFundCache(queryString) {
            let self = this;
            if (queryString !== undefined && queryString.length > 0) {
                self.searchPopoverVisible = true;
                self.loading2 = true;
                queryString = queryString.trim();
                clearTimeout(self.timeout);
                self.timeout = setTimeout(() => {
                    // getFundCache({ keyword: queryString, custom: true })
                    getFundCacheForMyList({ keyword: queryString, custom: true })
                        .then(response => {
                            let result = response.data;
                            if (result == undefined) {
                                Message({
                                    message: "数据异常，请尝试刷新再试！",
                                    type: "error",
                                    duration: 2 * 1000
                                });
                                Message.close = function() {};
                            } else {
                                if (checkResponseStatus(result, self)) {
                                    self.symbolList = result.data;
                                    self.searchDataByAutoComplete(queryString);
                                }
                            }
                        })
                        .catch(x => {
                            Message({
                                message: "网络超时，请重新尝试！",
                                type: "error",
                                duration: 3 * 1000
                            });
                            Message.close = function() {};
                        })
                        .finally(r => {
                            self.loading2 = false;
                        });
                }, 500);
            }
        },
        searchDataByAutoComplete(queryString) {
            const self = this;
            let results = self.symbolList;
            self.state.length = 0;
            self.state.push(
                "<span class='searchbox_symbol font_bold'>基金代码</span><span class='searchbox_title font_bold' style='min-width: 280px; width: 280px;'>基金名称</span>"
            );
            if (results !== undefined) {
                for (let i = 0; i < results.length; i++) {
                    const value = results[i].symbol + "    " + results[i].name;
                    let htmlString = value.replace(
                        queryString,
                        "<b style='color:red;'>" + queryString + "</b>"
                    );
                    htmlString = htmlString.replace(
                        "    ",
                        "</span><span class='searchbox_title' style='min-width: 280px; width: 280px;'>"
                    );
                    if (i === 0) {
                        self.firstSymbol = results[i].symbol;
                        self.state.push(
                            "<span class='searchbox_symbol'>" +
                                htmlString +
                                "</span>"
                        );
                    } else {
                        self.state.push(
                            "<span class='searchbox_symbol'>" +
                                htmlString +
                                "</span>"
                        );
                    }
                }
            }
            if (results === undefined || results.length === 0) {
                self.state.length = 0;
                self.state.push(
                    "<div class='center_text_align'>抱歉，没有找到和" +
                        "<b style='color:red;'>" +
                        queryString +
                        "</b>" +
                        "相关的内容</div>"
                );
            }
            self.$refs.search_scrollbar.update();
        },
        selectSymbolAutoComplete(symbolValue) {
            const self = this;
            if (
                symbolValue.indexOf(
                    "</span><span class='searchbox_title' style='min-width: 280px; width: 280px;'>"
                ) > -1
            ) {
                self.loading = true;
                self.searchPopoverVisible = false;
                symbolValue = symbolValue.split(
                    "</span><span class='searchbox_title' style='min-width: 280px; width: 280px;'>"
                )[0];
                symbolValue = symbolValue
                    .replace("<b style='color:red;'>", "")
                    .replace("<span class='searchbox_symbol'>", "")
                    .replace("</b>", "");
                getFundBySymbol({ symbol: symbolValue })
                    .then(response => {
                        let result = response.data;
                        if (result == undefined) {
                            Message({
                                message: "数据异常，请尝试刷新再试！",
                                type: "error",
                                duration: 2 * 1000
                            });
                            Message.close = function() {};
                        } else {
                            if (checkResponseStatus(result, self)) {
                                if (result.pagination != undefined) {
                                    self.pagination = result.pagination;
                                    self.pagination.count = 1;
                                }
                                self.tableData = result.data.latestEvaluation;
                            }
                        }
                    })
                    .catch(err => {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    })
                    .finally(r => {
                        self.loading = false;
                    });
            }
        },
        handleDownloadAll() {
            const self = this;
            self.dialogLoading = true;
            self.downloadAllVisible = false;
            //downloadAllVisible = false;
            sendAllReportByFTP()
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            Message({
                                message: "定时任务已启动，请半小时后查看FTP",
                                type: "success",
                                duration: 5 * 1000
                            });
                            Message.close = function() {};
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.dialogLoading = false;
                }); 
      },
      
      async closeDownloadMessage() {
        Message.closeAll();
        // 删除状态文件
        try {
          const match = this.downloadLink.match(/fundReports_(.+?)\.zip/);
          const key = match ? match[1] : '';
          const userStatusPath = `res/solution/userStatus/${key}.json`;
          console.log('[打点] 用户点击下载，删除状态文件参数', userStatusPath);
          const resp = await deleteFundReportsStatus({ key: userStatusPath });
          console.log('[打点] 删除状态文件结果', resp);
        } catch (e) {
          Message({
            message: "删除状态文件失败！" + (e.message || ''),
            type: "error",
            duration: 3 * 1000
          });
          console.log('[打点] 删除状态文件异常', e);
        }
      },

      async downloadAllFundReport() {
        this.downloadInProgress = true;
        console.log(this.downloadInProgress);
        Message({
          message: "下载链接生成中...预计需要15分钟，期间请不要关闭当前页面。",
          duration: 15 * 60 * 1000,
          showClose: true
        });

        let res = null;
        let fastTimeout = false;
        try {
          res = await Promise.race([
            getFundReports(),
            new Promise((_, reject) => setTimeout(() => { fastTimeout = true; reject(new Error('timeout')); }, 55000))
          ]);
        } catch (e) {
          fastTimeout = true;
        }

        if (fastTimeout || !res || !res.data || !res.data.data) {
          const maxTime = 18 * 60 * 1000;
          const pollInterval = 60000;
          let elapsed = 0;
          let pollResult = null;
          while (elapsed < maxTime) {
            await new Promise(resolve => setTimeout(resolve, pollInterval));
            elapsed += pollInterval;
            try {
              const pollRes = await getFundReportsStatus();
              if (pollRes && pollRes.data && pollRes.data.data && pollRes.data.data.zipUrl) {
                pollResult = pollRes.data.data;
                break;
              }
            } catch (e) {
              console.log('[打点] 轮询异常', e); // 打点
            }
          }
          if (!pollResult) {
            Message({ message: "查询超时，未获取到下载结果！", type: "error", duration: 3000 });
            this.downloadInProgress = false;
            return;
          }
          res = { data: { data: pollResult } };
        }

        const { zipUrl, focusCount } = res.data.data;
        if (focusCount > 3000) {
          Message({
            message: "数量超过3000，无法下载！",
            type: "warning",
            duration: 3000
          });
          this.downloadInProgress = false;
          return;
        }

        if (!zipUrl) {
          Message({
            message: "未获取到下载地址！",
            type: "error",
            duration: 3000
          });
          this.downloadInProgress = false;
          return;
        }

        this.downloadLink = "https://res.morningstar.cn/" + zipUrl;
        if (this.downloadLink) {
          Message.closeAll();
          window.closeDownloadMessage = () => {
            this.closeDownloadMessage();
          };
          Message({
            dangerouslyUseHTMLString: true,
            message: `<span>下载链接生成完毕，请点击 <a href='${this.downloadLink}' target='_blank' style='color:#409EFF;font-weight:bold;' onclick="window.closeDownloadMessage()">下载报告压缩包</a></span>`,
            duration: 0,
            showClose: true
          });
        }
        this.downloadInProgress = false;
      },
      
        removeMyList() {
            const self = this;

            let confirmResult = confirm("确认清空基金代码？");

            if(confirmResult)
            {
              let params = {};
              removeMyList()
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {

                            self.loadingData();
                            Message({
                                message: "基金代码列表已经清空！",
                                type: "success",
                                duration: 5 * 1000
                            });
                            Message.close = function() {};
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.dialogLoading = false;
                });
            }           
        }
    }
};
</script>
<style lang="scss">
@import "../../public/sass/components/latestEvaluation";
</style>
